import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/App.css';
import Container from './Container';
import ZwykHero from './ZwykHero';
import ZwykFeatures from './ZwykFeatures';
import ZwykFooter from './ZwykFooter';
import ZwykDescription from './ZwykDescription';
import ZwykPartners from './ZwykPartners';
import CookieBanner from './CookieBanner';
import AOS from "aos";
import "aos/dist/aos.css";

const App: React.FC = () => {
    useEffect(() => {
      AOS.init({
        once: true,
        disable: "phone",
        duration: 600,
        easing: "ease-out-sine",
      });
  }, []); // Added empty dependency array
  return (
    <div className="App">
      <main>
        <section className='page-section section-0'>
          <img src={require('../assets/eu-template.jpg')} alt="Hero template" className='hero-template' />
          <Link to="/dofinansowanie" className='eu-funding-link'>Dowiedz się więcej</Link>
        </section>
        <section className='page-section section-1'>
          <Container />
        </section>
        <section className='page-section section-2'>
          <ZwykPartners />
        </section>
        <section className='page-section section-3'>
          <ZwykDescription />
        </section>
        <section className='page-section section-4'>
          <ZwykHero />
        </section>
        <section className='page-section section-5'>
          <ZwykFeatures />
        </section>
        <section className='page-section section-6'>
          <ZwykFooter />
        </section>
      </main>
      <CookieBanner />
    </div>
  );
};

export default App; 